<template>
	<div class="stepper-container">
		<div v-for="(step, index) in steps" :key="step">
			<div class="step">
				<div style="display: flex; flex-direction: row">
					<div class="ball-container center">
						<div
							:class="[
								'ball center',
								currentStep > index + 1 && 'complete',
								currentStep === index + 1 && 'active'
							]"
						>
							<p class="number">
								{{ index + 1 >= currentStep ? index + 1 : '' }}
							</p>
						</div>
						<p
							:class="[
								'step-name',
								currentStep >= index + 1 && 'complete'
							]"
						>
							{{ step }}
						</p>
					</div>
					<div v-if="index + 1 < stepCount" class="line" />
				</div>
			</div>
		</div>
	</div>
</template>

<script>
import { isMobileScreenSize } from '../utilities'

export default {
	name: 'stepper',
	props: ['steps', 'currentStep'],
	computed: {
		stepCount() {
			return this.steps.length
		}
	},
	methods: {
		isMobileScreenSize
	}
}
</script>

<style lang="scss">
@import '../styles/elements';
.stepper-container {
	display: flex;
	flex-direction: row;
	justify-content: space-around;
	height: 60px;
	margin-top: 25px;
	padding-left: 25px;
	padding-right: 25px;
	margin-bottom: 0px;
	@media screen and (max-width: 480px) {
		margin-top: 15px;
		height: 50px;
	}
	@media screen and (max-width: 350px) {
		margin-top: 15px;
		height: 40px;
	}
}
.step {
	p {
		color: $slate;
	}
	display: flex;
	flex: 1;
	flex-direction: column;
	justify-content: center;
	align-items: center;
	padding-left: 5px;
	margin-bottom: 0px;
	.step-name {
		font-size: 12px;
		text-align: center;
		margin-top: 5px;
		color: rgba(0, 0, 0, 0.54);
		&.complete,
		&.active {
			color: $navy;
		}
		@media (max-width: 480px) {
			display: none;
			height: 0px;
		}
	}
	.ball-container {
		position: relative;
		width: 60px;
		.ball {
			font-size: 14px;
			color: rgba(0, 0, 0, 0.54);
			height: 30px;
			width: 30px;
			border-radius: 25px;
			border: 2px solid $light-navy;
			font-weight: 500;
			&.complete {
				background: url('../assets/step_completed.svg');
				background-repeat: no-repeat;
				background-position: center;
				background-size: cover;
				color: transparent;
				border: none;
			}
			&.active {
				font-weight: bold;
				border-width: 2px;
				border-color: $navy;
				font-weight: 700;
				color: $navy;
			}
			@media screen and (max-width: 350px) {
				height: 20px;
				width: 20px;
				.number {
					display: none;
				}
			}
		}
		@media screen and (max-width: 350px) {
			width: 50px;
		}
	}
	.line {
		background: $navy;
		height: 2px;
		width: 50px;
		margin-top: 15px;
		@media screen and (max-width: 480px) {
			width: 30px;
		}
		@media screen and (max-width: 350px) {
			width: 30px;
			margin-top: 10px;
		}
	}
}
</style>
